import knowledgeBaseClient from '../services/http-client';
import { createModuleQueryKeys } from '../../createModuleQueryKeys';
import { useModuleQuery } from '../../useModuleQuery';
import type { CompanyResponse, StatisticsResponse } from './interfaces';

export const knowledgeBaseKeys = {
  ...createModuleQueryKeys('knowledge-base-module'),
  company: (clientId: string | null) => [...knowledgeBaseKeys.all(clientId), 'company'] as const,
  statistics: (clientId: string | null) => [...knowledgeBaseKeys.all(clientId), 'statistics'] as const,
};

// GET /company — read company data (address, opening hours, contact)
export const useCompanyQuery = () =>
  useModuleQuery({
    queryKey: knowledgeBaseKeys.company,
    request: () => knowledgeBaseClient.get<CompanyResponse>('/company'),
    staleTime: 0,
    refetchOnMount: 'always',
  });

// GET /statistics — fetch all indexing statistics (client-side pagination)
export const useStatisticsQuery = () =>
  useModuleQuery({
    queryKey: knowledgeBaseKeys.statistics,
    request: () =>
      knowledgeBaseClient.get<StatisticsResponse>('/statistics', {
        params: { limit: 10000, offset: 0 },
      }),
    staleTime: 0,
    refetchOnMount: 'always',
  });
